'use client';

import { Box, Stack, Typography } from '@mui/material';
import FolderOffOutlined from '@mui/icons-material/FolderOffOutlined';

export type ProjectSearchNoRowsOverlayProps = {
  /** When true, explain that results are limited to the current user’s collaborator projects. */
  ownProjectsOnly: boolean;
};

/**
 * Shown in the project search grid when the server returns zero rows (not while loading).
 */
export function ProjectSearchNoRowsOverlay({ ownProjectsOnly }: ProjectSearchNoRowsOverlayProps) {
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 280,
        width: '100%',
        px: 2,
        py: 4,
      }}
    >
      <Stack alignItems="center" spacing={1.5} sx={{ maxWidth: 520, textAlign: 'center' }}>
        <FolderOffOutlined sx={{ fontSize: 48, color: 'text.secondary', opacity: 0.85 }} aria-hidden />
        <Typography variant="h6" component="h2">
          No projects found
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Nothing matched your current search and filters. Open <strong>Filter</strong>, adjust criteria, then click{' '}
          <strong>Apply</strong> — search text, project type, materials, PI geography, status, and other options all
          narrow the list.
        </Typography>
        {ownProjectsOnly ? (
          <Typography variant="body2" color="text.secondary" sx={{ pt: 0.5 }}>
            <strong>My projects</strong> is on, so only projects where you are a collaborator are included. Try
            unchecking <strong>My projects</strong> in the search bar, then apply again.
          </Typography>
        ) : null}
      </Stack>
    </Box>
  );
}
